import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

import { Sidebar, Topbar, Footer } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    paddingTop: 56,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 56
    }
  },
  shiftContent: {
    paddingLeft: 260
  },
  content: {
    flexGrow: 1,
    height: '100%',
    padding: theme.spacing(3)
  }
}));

const Main = props => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(isDesktop);

  const handleSidebarOpen = () => {
    setOpenSidebar(!openSidebar);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  //const shouldOpenSidebar = isDesktop ? true : openSidebar;
    React.useEffect(() => {
      setOpenSidebar(isDesktop);
    }, [isDesktop])

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: (openSidebar && isDesktop)
      })}
    >
      <Sidebar
        onClose={handleSidebarClose}
        open={openSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <Topbar onSidebarOpen={handleSidebarOpen} />
      <main className={classes.content}>
        {children}
            <Footer />
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
